export default "images/mailbox.svg";